import React, { Component } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { Row, Col, Card, Icon, Table, Button, Popconfirm, message } from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import { Translate } from "react-translated";
import { useBoundStore } from "../../store/useBoundStore";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';

class InactiveUsers extends Component {
  state = {
    loading: true,
    users: [],
    user: {},
    user_type: useBoundStore.getState().userType
  };
  componentDidMount = () => {
    //  console.log("useBoundStore.getState()",useBoundStore.getState().userType)
    this.loadUsers(1);
  };
  componentDidUpdate = (prevProps) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.loadUsers(1)
    }
  }
  loadUsers = (page) => {
    let user = JSON.parse(Cookies.get("user_info"));
    const users_list = [];
    // const historyState = this.props.history.location;
    let api =
      user.user_type == "SUPER_ADMIN" && this.state.user_type === 'SUPER_ADMIN'
        ? "/api/inactive_users_sa"
        : `/api/inactive_users${this.state.user_type && "?user_type=" + this.state.user_type || ""}`
    this.setState({ loading: true });

    axios.get(api).then((res) => {
      const users = res.data.results;
      this.setState({ loading: false, users: Array.isArray(users) ? users : [] });
    });
  };
  enable = (id) => {
    this.setState({ loading: true });
    axios
      .put("/api/update_user_token/" + id, {
        active: 1,
      })
      // .put("/api/users/" + id, {
      //   active: 1,
      // })
      .then(() => {
        message.success(F.translate(`User has been enabled.`));
        this.setState({ loading: false }, () => {
          this.loadUsers(1);
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error(F.translate(`Can't enable the user.`));
      });
  };

  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }


  render() {
    const { loading, users } = this.state;

    // Define AgGrid column definitions
    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"First Name"} />,
        field: 'first_name',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['First Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'first_name',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.first_name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Last Name"} />,
        field: 'last_name',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Last Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'last_name',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.last_name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Email"} />,
        field: 'email',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Email'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'email',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.email}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"User Type"} />,
        field: 'user_type',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['User Type'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'user_type',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.user_type}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Actions"} />,
        field: 'action',
        minWidth: 300,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Actions'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'action',
        }),
        cellRendererFramework: (params) => (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%', height: '100%' }}>
            <Link to={"/manage-users/edit-user/" + params.data.id}>
              <Button className="borderRadius-28">
                <Icon type="edit" /> <Translate text={`Edit User`} />
              </Button>
            </Link>
            <Button
              type="primary"
              onClick={() => this.enable(params.data.id)}
              className="bg-164897 borderRadius-28"
              style={{ marginLeft: 10 }}
            >
              <Icon type="plus" /> <Translate text={`Enable User`} />
            </Button>
          </div>
        ),
      },
    ];

    const data = [];
    for (let i = 0; i < users.length; i++) {
      let user = users[i];
      data.push({
        key: i,
        id: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        user_type:
          user.user_type == "LSP (Onboarding & Life Licensed)" ||
            user.user_type == "LSP (Life Licensed)" ||
            user.user_type == "LSP (Onboarding)" ||
            user.user_type == "LSP"
            ? "Agency Staff"
            : user.user_type === "VONBOARDER" ? "Follow-Up Specialist" : user.user_type,
      });
    }

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`Inactive Users`} />
            </div>
          }
          className="tableCard"
          loading={loading}
        >
          <CustomAgGridTable
            onGridReady={this.onGridReady}
            onColumnMoved={this.saveState}
            onSortChanged={this.saveState}
            onFilterChanged={this.saveState}
            rowDatas={data}
            columnDefss={columnDefs}
          />
        </Card>
      </div>
    );
  }
}

export default InactiveUsers;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/inactive-users.js